import React from 'react'
import { Card } from 'react-bootstrap'

const dentalCardStyle = {
  borderColor: '#d6c4f2',
}

const dentalCardHeaderStyle = {
  backgroundColor: '#efe7ff',
  borderBottomColor: '#d6c4f2',
  fontSize: '15px',
  fontWeight: 'bold',
}

const DentalDataCard = ({ title, children }) => (
  <Card className="mb-3" style={dentalCardStyle}>
    <Card.Header className="p-3" style={dentalCardHeaderStyle}>
      {title}
    </Card.Header>
    <Card.Body className="p-3">{children}</Card.Body>
  </Card>
)


export default DentalDataCard
